import type { MaxNumberOfTrips, MaxTimeWindow, MinTimeWindow, SupportedLocale, TimeFormat } from "../types/types";
import { supportedLocales } from "../../package.json";

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
export const APP_REFRESH_INTERVAL = HOUR;
export const APP_REFRESH_INTERVAL_ON_ERROR = MINUTE;
export const SCROLL_MORE_DELAY = 30; // seconds
export const SWITCH_DISPLAY_DELAY = 60; // seconds
export const SCROLL_BOTTOM_PAUSE_DURATION = 10; // seconds
export const SCROLL_BY_ROW_SPEED = 2; // row/second
export const SERVICE_REFETCH_INTERVAL = MINUTE; // ms
export const SERVICE_ROW_HEIGHT = 92; // px
export const PLATFORM_MAX_LENGTH = 3; // character
export const SERVICE_STATE_SWITCH_BETWEEN_LOCALE_EVERY = 3; // seconds
export const CURRENT_STATION_SWITCH_BETWEEN_LOCALE_EVERY = 3; // seconds
export const STOP_LIST_SCROLL_BY_CHARACTER_SPEED = 0.2; // character/second
export const STOP_LIST_SPACING = 25; // characters
export const SUPPORTED_LOCALES = [...supportedLocales] as const;
export const DISPLAY_MODE = {
	ARRIVAL: "arrival",
	DEPARTURE: "departure",
	BOTH: "both",
} as const;
export const MIN_TIME_WINDOWS = [5, 10, 15, 30, 60, 240] as const; // minutes
export const DEFAULT_MIN_TIME_WINDOW: MinTimeWindow = 5; // minutes
export const MAX_TIME_WINDOWS = [30, 60, 120, 180, 240, 360, 720, 1080] as const; // minutes
export const DEFAULT_MAX_TIME_WINDOW: MaxTimeWindow = 360; // minutes
export const MAX_NUMBER_OF_TRIPS = [6, 12, 18, 24, 30, 35, 40, 50] as const; // trips
export const DEFAULT_MAX_NUMBER_OF_TRIPS: MaxNumberOfTrips = 12; // trips
export const DEFAULT_DISPLAY_MODE = DISPLAY_MODE.DEPARTURE;
export const DEFAULT_LOCALE: SupportedLocale = "en-US";
export const TIME_FORMATS = [12, 24] as const; // hours
export const DEFAULT_TIME_FORMAT: TimeFormat = 24;
